import { InvWidgetResources } from "../types/inventoryWidgetTypes";

export const invWidgetResources: InvWidgetResources = {
  orMore: "or more",
  orLess: "or less",
  maxPrice: 99999999,
  minPrice: 1,
  filterAttribute: "inventory-filter",
  searchParamAttribute: "inventory-search-param",
  actionAttribute: "inventory-action",
  infoAttribute: "inventory-info",
  placeholderAttribute: "inventory-filter-placeholder",
  dependAttribute: "inventory-depend-on",
  defaultPriceRanges: [
    { low: null, high: 5000 },
    { low: 5001, high: 10000 },
    { low: 10001, high: 15000 },
    { low: 15001, high: 20000 },
    { low: 20001, high: 25000 },
    { low: 25001, high: 30000 },
    { low: 30001, high: 40000 },
    { low: 40001, high: 50000 },
    { low: 50001, high: 60000 },
    { low: 60001, high: null },
  ],
  defaultAnimationDuration: 1000,
  defaultPlaceholder: "Any {field}",
  filterPattern: /(\w+):?(\w*)/,
  staticFilter: "condition",
  updateFilters: "update-filters",
};
